import moment from 'moment';
import { isEmpty, cloneDeep } from 'lodash-es';

import { newMathFormat } from '@intelligence/utils/commonUtils';
// import { formatDateStr, getRoundIntegerNum, getNullableMoment } from '@gp/utils/common';
import { formatDateStr, getRoundIntegerNum } from '@gp/utils/common';

type IHistory = {
  [key: string]: number;
};

type IHistoryRecord = {
  date: string;
  value: number;
};

export const transferHistories = (list: IHistory[]): IHistoryRecord[] => {
  if (!Array.isArray(list) || !list.length) return [];
  const result: IHistoryRecord[] = [];

  for (const item of list) {
    const [date, value] = Object.entries(item || {})?.[0] || [];
    if (!!date) {
      result.push({
        date,
        value: getRoundIntegerNum(value, Number.NaN as any, false) as any,
      });
    }
  }

  return result.sort((a, b) => (moment(a.date).isAfter(moment(b.date)) ? 1 : -1));
};

export const getChartData = (list: any): any[] => {
  if (!Array.isArray(list) || !list.length) return [];
  return list.map((item) => {
    const { date, value } = item || {};
    return {
      category: formatDateStr(date),
      value,
      data: { ...item },
    };
  });
};

export const getTextWithPlaceholder = (data: any, placeholder = '-') => (!isEmpty(data) ? data : placeholder);

export const formatDataTableBudgetColumnKey = (list?: any[] | null): any[] => {
  if (!Array.isArray(list) || !list.length) return [];
  const res: Record<string, any> = {};

  try {
    for (const item of list) {
      const { date, details } = item || {};
      for (const detail of details) {
        const { name, value } = detail || {};

        if (!Reflect.has(res, name)) {
          res[name] = {};
        }

        if (!value) {
          res[name][date] = '-';
        } else {
          res[name][date] = newMathFormat(value, true);
        }

        res[name].type = name;
      }
    }

    return Object.values(res);
  } catch (exception) {
    console.error('An error occurred during data transformation:', exception);
    return [];
  }
};

const SPECIAL_KEYS = ['headcount', 'type'];
export const transformDataTableHeadcountColumnKey = (list: Record<string, string>[]): any[] => {
  if (!Array.isArray(list) || !list.length) return [];
  const transformedData = [];

  try {
    for (const item of list) {
      const transformedObj: Record<string, any> = {};

      for (const [key, value] of Object.entries(item || {})) {
        if (SPECIAL_KEYS.includes(key)) {
          transformedObj[key] = value;
        } else {
          transformedObj[key] = value === '' ? '-' : getRoundIntegerNum(value);
        }
      }

      transformedData.push(transformedObj);
    }
  } catch (error) {
    console.error('An error occurred during data transformation:', error);
    // 添加兜底处理，返回空数组或其他默认值

    return [];
  }

  return transformedData;
};

const METRIC_SORT_KEYS = ['net_profit_ratio', 'y1_sales', 'y1_copies', 'y3_sales', 'y3_copies'];
export const sortMetrics = <T extends { metric: string; }>(list: T[]): T[] => {
  if (!Array.isArray(list) || !list.length) return [];

  return cloneDeep(list).sort((a, b) => {
    const indexA = METRIC_SORT_KEYS.indexOf(a?.metric);
    const indexB = METRIC_SORT_KEYS.indexOf(b?.metric);
    return indexA - indexB;
  });
};
